import { AppPlugin } from '~/plugins/_types';
import router from '~/plugins/router';
import { init, browserTracingIntegration } from '@sentry/vue';
import config from '~/plugins/config';

// @plachtova  todo: po aktualizaci sentry balicku byly provedeny migracni zmeny, ktere nebyly odzkouseny
//pokud budeme chtit Sentry pouzvat, tak je potreba ho prekontrolovat
export default {
    name: 'sentry',
    install: async (app) => {
        init({
            app,
            enabled: config.sentry.enabled,
            dsn: config.sentry.dsn,
            environment: config.env.mode,
            release: config.sentry.release,
            integrations: [browserTracingIntegration({ router })],
            // Performance Monitoring
            tracesSampleRate: 0.3,
            // Session Replay
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });
    },
    priority: 9,
} satisfies AppPlugin;
